import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { QrObrasService } from "../services/qr-obra-service";

@Injectable({
  providedIn: 'root'
})
export class QrObraVerifyProjectResolver implements Resolve<boolean> {

  constructor(private service: QrObrasService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let obj = {
      project_full_id: route.queryParams?.project_full_id,
      pf_prt_issue_id: route.queryParams?.pf_prt_issue_id,
    }

    return this.service.getVerifyProject(obj);
  }
}